import { SecondaryMenu } from "../../atoms";
import Header from "../../atoms/Header";

export default function Navbar() {
  return (
    <Header>
      <SecondaryMenu />
    </Header>
  );
}
